<template>
  <div>
    <div>
      <load-progress :condition="progress" label="Chargement du fichier en cours"></load-progress>
    </div>

    <select-field :editFieldInfo="exportTypeFieldInfo"
                  :items="items"
                  :value="selectedExportType.title"
                  @updated="setSelectedExportType">
    </select-field>

    <edit-field :editFieldInfo="fileNameFieldInfo" :value="fileName" @updated="setFileName"></edit-field>

    <!--<check-field v-if="!config.exportSelected"
                 :editFieldInfo="exportFilteredFieldInfo"
                 :value="exportFiltered"
                 @updated="setExportFiltered">
    </check-field>

    <div class="py-2">
      <span>{{ attributeTableLabel }}</span>
      <v-data-table :headers="attributeListHeaders"
                    no-data-text="Aucune donn�e"
                    :items="exportableAttributes"
                    v-model="selectedExportAttributes"
                    :itemsPerPage="-1"
                    showSelect
                    disablePagination
                    hideDefaultFooter
                    dense>
      </v-data-table>
    </div>-->

    <div class="d-flex flex-row-reverse mt-4">
      <loader-button :label="buttonClose"
                     class="ms-2"
                     @callback="closeDialog">
      </loader-button>
      <loader-button :label="buttonAction"
                     :disabled="exportDisabled"
                     class="ms-2"
                     @callback="exportFile">
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import LoadProgress from '@/framework/base/components/LoadProgress.vue';
import {AdminExport} from '@/generated/classes/Admin';
import {ExportType} from '@/generated/classes/Files';
import Files, {DownloadData} from '@/generated/classes/Files';
import {getBlob} from '@/framework/files/helpers/FileTypes';
import {
  FwkButtons,
  FwkControls,
  FwkSections,
  RessourceFwkButton,
  RessourceFwkControl,
  RessourceFwkSection
} from '@/ressources/globalRessources';
import Item from '@/framework/base/classes/Item';
import SelectField from '@/framework/base/components/SelectField.vue';
import {EditFieldType, FieldInfo} from '@/framework/base/components/FieldInfo';
import EditField from '@/framework/base/components/EditField.vue';
import AdminAttrib from '@/generated/classes/AdminAttrib';
import {defineComponent, type PropType} from "vue";

export default defineComponent({
  components: {
    EditField,
    SelectField,
    LoadProgress,
    LoaderButton
  },
  props: {
    showDialog: {
      type: Boolean
    },
    config: {
      type: Object as PropType<AdminExport>,
      required: true
    },
    fields: {
      type: Array as PropType<AdminAttrib[]>,
      required: true
    }
  },
  created() {
    const date = new Date();
    const year = date.toLocaleString("default", {year: "numeric"});
    const month = date.toLocaleString("default", {month: "2-digit"});
    const day = date.toLocaleString("default", {day: "2-digit"});
    this.fileName = `${year}-${month}-${day}-${this.config.table}`; // set table name as default file name
    this.exportFiltered = this.config.exportSelected;

    this.selectedExportAttributes = this.exportableAttributes;
    if (this.config.possibleType.length == 1) {
      const item = this.config.possibleType[0];
      this.selectedExportType = new Item(0, item.type);
    }
  },
  data() {
    const selectedExportAttributes: AdminAttrib[] = [];
    const selectedExportType: Item = new Item('', '');

    return {
      progress: false,
      buttonAction: RessourceFwkButton(FwkButtons.EXPORTER).label,
      buttonClose: RessourceFwkButton(FwkButtons.FERMER).label,
      selectedExportType,
      fileName: '',
      exportFiltered: false,
      attributeListHeaders: [
        {text: RessourceFwkSection(FwkSections.EXPORT_ATTRIBUTE_LIST_HEADER).label, value: 'value'}
      ],
      attributeTableLabel: RessourceFwkSection(FwkSections.EXPORT_ATTRIBUTE_LIST).label,
      selectedExportAttributes
    };
  },
  computed: {
    exportTypeFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.TYPE_EXPORT);
      const type = EditFieldType.CHOIX;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
    fileNameFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.FILE_NAME);
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
    exportFilteredFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.EXPORT_FILTERED);
      const type = EditFieldType.BOOL;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
    items(): Item[] {
      const items: Item[] = [];
      this.config.possibleType.forEach((exportType: ExportType, index: number) => items.push(new Item(index, exportType.type)));
      return items;
    },
    exportDisabled(): boolean {
      return this.progress || this.selectedExportType.title == '' || this.fileName == '' || this.selectedExportAttributes.length == 0;
    },
    exportableAttributes(): AdminAttrib[] {
      return this.fields.filter((item) => !item.readOnly && item.value !== 'status');
    }
  },

  methods: {
    setFileName(value: string) {
      this.fileName = value;
    },
    setExportFiltered(value: boolean) {
      this.exportFiltered = value;
    },
    setSelectedExportType(selectedOption: Item) {
      this.selectedExportType = selectedOption;
    },
    closeDialog() {
      this.progress = false;
      this.$emit('closeDialog');
    },
    exportFile(): void {
      this.progress = true;
      const data = new DownloadData();
      data.service = this.config.service;
      data.type.type = this.selectedExportType.title;
      data.type.extension = this.config.possibleType[this.selectedExportType.key].extension;
      data.data = JSON.parse(JSON.stringify(this.config));

      if (!this.exportFiltered) {
        (data.data as AdminExport).dataIds = [];
      }

      if (this.selectedExportAttributes.length > 0) {
        this.selectedExportAttributes.forEach((att: AdminAttrib) => (data.data as AdminExport).attributes.push(att.value));
      }

      Files.download(data)
          .then((buffer) => {
            const blob = getBlob(buffer, data.type.extension);
            const file = window.URL.createObjectURL(blob);
            const docUrl = document.createElement('a');
            docUrl.setAttribute('href', file);
            docUrl.setAttribute('download', `${this.fileName}.${data.type.extension}`);
            document.body.appendChild(docUrl);
            docUrl.click();
            this.progress = false;
          });
    }
  }
})

</script>

<style scoped>
.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: 25px !important;
}
</style>
